<template>
  <v-container
    fluid
    v-if="accessViewEquipmentShelter()"
  >
    <base-material-card
      inline
      icon="mdi-dip-switch"
      title="Equipment shelter"
    >
      <empty-space />
      <v-form>
        <common-search
          ref="cs"
          v-model="commonSearch"
        ></common-search>
        <v-row>
          <v-col cols="3">
            <text-field
              label="Shelter type"
              v-model="shelter_type"
            ></text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              color="primary"
              @click="doFilter"
            >Filter</v-btn>
            <v-btn
              color=""
              @click="doCancel"
            >Cancel</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </base-material-card>
    <v-card
      class="v-card--material pa-3"
    >
      <h2>Results</h2>
      <data-table
        ref="table"
        :fetch-from="fetchForm"
        :fields="fields"
      >
        <template
          slot="site"
          slot-scope="slotData"
        >
          <v-btn
            @click="openSite(slotData.rowData.site.id)"
            outlined
            flat
            small
          >{{ slotData.rowData.site.site_id_display }} {{ slotData.rowData.site.site_name }}</v-btn>
        </template>
      </data-table>
    </v-card>
  </v-container>
</template>

<script>
  import DataTable from '../../components/DataTable'
  import DatePicker from '../../components/DatePicker'
  import NewUsed from '../../components/codelist/NewUsed'
  import EmptySpace from '../../components/EmptySpace'
  import BatteryType from '../../components/codelist/BatteryType'
  import BatteryStatus from '../../components/codelist/BatteryStatus'
  import ConstructionShelterService from '@/services/construction-shelter'
  import TextField from '@/components/TextField'
  import TowerDesigner from '@/components/codelist/TowerDesigner'
  import TowerManufacturer from '@/components/codelist/TowerManufacturer'
  import PermissionsMixin from '@/mixins/Permissions'
  import CommonSearch from '@/views/equipment/CommonSearch'
  export default {
    name: 'Shelter',
    mixins: [
      PermissionsMixin,
    ],
    components: { CommonSearch, TowerManufacturer, TowerDesigner, TextField, BatteryStatus, BatteryType, EmptySpace, NewUsed, DatePicker, DataTable },
    data: () => ({
      commonSearch: {},
      shelter_type: undefined,
      fields: [
        {
          name: 'shelter_type',
          title: 'Shelter type',
        },
        {
          name: '__slot:site',
          title: 'Site',
        },
      ],
    }),
    methods: {
      fetchForm (urls, options) {
        const cas = new ConstructionShelterService()
        const searchFilter = JSON.parse(JSON.stringify(this.commonSearch))
        searchFilter.shelter_type = this.shelter_type
        return cas.filter(searchFilter, options.params)
      },
      openSite (siteId) {
        const url = '/#/sites/' + siteId + '/view'
        var win = window.open(url, '_blank')
        win.focus()
      },
      doFilter () {
        this.$refs.table.refresh()
      },
      doCancel () {
        this.$refs.cs.clear()
        this.tower_type = undefined
        this.shelter_type = undefined
        this.tower_designer = undefined
        this.tower_manufacturer = undefined
        this.$refs.table.refresh()
      },
    },
  }
</script>

<style scoped>

</style>
